// import useConfig from './useConfig'
import { useQueries } from 'react-query'

/**
 * Hook for retrieving the skins data.
 */


const useGetScoringData = () => {
  /*
  const { data: config } = useConfig()
*/

  const fetchCourses = async () => {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}api/courses/readWeeklyCourse.php`);
    return resp.json();
  }

  const fetchMembers = async () => {
    const resp = await fetch(`${process.env.REACT_APP_API_URL}api/players/read.php?option=Active`);
    return resp.json();
  }

  const resp = useQueries([
    {queryKey: ["courses"], queryFn: fetchCourses},
    {queryKey: ["members"], queryFn: fetchMembers}
    ])
  
  const mergedResponse = {
    courses: resp[0].data,
    members: resp[1].data
  };
  return mergedResponse 
}

export default useGetScoringData
